import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, AbstractControl, FormControl, Validators } from '@angular/forms';
import { pairwise, startWith } from 'rxjs/operators';

import { CommonService } from '../../../shared/services/common.service';
import { CreateBookingService } from '../create-booking.service';
import { BaseFormGroup } from '../../../shared/form-input-components/base-form-group';
import { UtilService } from 'src/app/shared/services/util.service';
import { FormConstants } from '../../../core/globals/form-constants';
import { AuthService } from 'src/app/shared/services/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { MyBookingsService } from '../../my-bookings/my-bookings.service';
import { DropdownItem } from 'mis-crystal-design-system/dropdown';


@Component({
  selector: 'app-trip-details',
  templateUrl: './trip-details.component.html',
  styleUrls: ['./trip-details.component.scss', '../../../shared/styles/form.scss']
})
export class TripDetailsComponent extends BaseFormGroup implements OnInit, OnDestroy {

  @Input() formDetails: FormGroup;
  @Input() userDetails: any;
  @Input() bookingEditConfig: any;
  @Input() bookingCreationCutoff: any;
  @Input() uploadedDocuments: any;
  @Input() referenceBooking: any;
  @Input() miscellConfig: any;
  @Input() workflowConfig: any;
  @Input() configComplete: any;
  @Input() designationConfig: any;
  @Input() engagementForm: FormGroup;
  @Input() isAllGuest: boolean;

  public UploadedDocumentMap: any = new Map();
  public tripDetailsConfig: any[] = [];
  viewRateCardElement;
  public dateWiseConfig: any [] = [];
  public cabCountConfig: any;
  public cabConfig: any[] = [];
  public isDateRemoveWarning: boolean;
  public isDateMergeWarning: boolean;
  isLoading = false;
  private prevDate: any[];
  private nextDate: any[];
  public acceptWarningCallback: any;
  public dismissWarningCallback: any;
  private isChangedInCard = false;
  private watchers = [];
  private diabledDays = [];
  private weekDaysMapping = FormConstants.weekDaysMapping;
  rateCardImageURL: string;
  imageLoading = false;
  showImage = false;
  errorInGettingImage: boolean;
  fileName = '';
  displayFileName = '';
  documentUploaded = false;
  filesize: any;
  uploadDocumentsExceeded = false;
  fileSizeExceeded = false;
  uploadedDocumentList: any = [];
  deleteDocPopup = false;
  selectedFiles: File[] = [] ;
  deleteDocName = '';
  submitDocumentId: any = '';
  showSuccessToast = false;

  editBookingId = '';
  toastMsg = '';
  enableBackDatedBooking = false;
  isBackDatedBooking = false;
  disableOnEdit = false;
  showDates = false;

  billableTypes: DropdownItem[] = [{label:'Billable' ,value: 'Billable'}, {label:'Non-Billable' ,value: 'Non-Billable'}]

  constructor(private commonService: CommonService, private createBookingService: CreateBookingService,
              private formBuilder: FormBuilder, private utilService: UtilService,
              private authService: AuthService, private myBookingService: MyBookingsService,
              private sanitizer: DomSanitizer, private activatedRoute: ActivatedRoute, ) {
                super();
              }

  ngOnInit() {
    this.isLoading = true;
    this.authService.getServerTime({buid: this.authService.user.buId}).subscribe((res) => {
      this.authService.serverTime = res;
      const pageConfig = this.commonService.getConfigForElementKey(this.configComplete, 'Trip Details Form').elementConfigList;
      for (const element of pageConfig) {
          const key = element.elementKey;
          if (element.config.elementType === 'datepicker') {
            element.config.minDate = this.utilService.getMoment();
            element.config.disabledDaysInWeek = this.bookingCreationCutoff.disabledForWeeks;
          }

          if (key === 'DateSelection') {
            if (!this.createBookingService.isEditMode) {
              this.tripDetailsConfig.push(element);

            } else {
              const dateConfig = this.utilService.deepCopy(element);
              dateConfig.config.values = [1];
              dateConfig.config.minDate = this.utilService.getMoment();
              this.tripDetailsConfig.push(dateConfig);
            }
          } else if (key === 'viewRateCard') {
            this.viewRateCardElement = element;
          } else if (key === 'Date Toggle') {
            this.tripDetailsConfig.push(element);
          } else if (key === 'CabCount' || key === 'CabToggle' || key === 'BookingMultiDate') {
            this.dateWiseConfig.push(element);
            this.cabCountConfig = element;
          }
          else {
            this.cabConfig.push(element);
          }
        }
      this.setupForm();
      this.isLoading = false;

    });

    this.createBookingService.savedDocuments.subscribe(res => {
      this.uploadedDocumentList = [];
      this.uploadedDocumentList = res;
    });

    this.createBookingService.selectedFilesObj.subscribe(res => this.selectedFiles = res);
    if (this.createBookingService.isEditMode){
      this.enableBackDatedBooking = this.referenceBooking['backDatedBooking'];
      this.disableOnEdit = true;
      this.createBookingService.createBackDatedBooking.next(this.enableBackDatedBooking);
      this.activatedRoute.queryParams.subscribe(param => {
        this.editBookingId = param.bookingId;
        this.myBookingService.fetchDocuments(this.editBookingId).subscribe(res => {
        this.uploadedDocumentList = Object.entries(res).slice(1).map(([filename, filesize]) => ({ filename, filesize }));
        this.selectedFiles = [];
      }); });
    }else {
    this.createBookingService.createBackDatedBooking.subscribe(res => this.enableBackDatedBooking = res);
    }
  }

  closePopOver() {
    this.showImage = false;
    this.rateCardImageURL = "";
    this.errorInGettingImage = false;
  }

  showRateCard() {
    this.showImage = true;
    const request = {
      buid: this.authService.user.buId,
      client: this.authService.client.client
    };
    this.imageLoading = true;
    this.createBookingService.getRateCard(request).subscribe((resp) => {
      const blob = new Blob([resp.body], {type: 'jpeg'});
      const url = window.URL.createObjectURL(blob);
      this.rateCardImageURL = url;
      this.imageLoading = false;
    },
    (error) => {
      this.errorInGettingImage = true;
      this.imageLoading = false;
    }
    );
  }

  getSafeUrl() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.rateCardImageURL); }


  setupForm() {
    if (!Object.keys(this.formDetails.controls).length) {
      const formGroup = this.formBuilder.group({});
      this.constructForm(formGroup, this.tripDetailsConfig);
      this.formDetails.addControl('tripDetails', formGroup);
      this.formDetails.addControl('dateWise', new FormArray([]));
    }

    if(this.miscellConfig?.verifyEngagementCode){
      // check if one already exists
      if(!this.formDetails.get('billableType')){
        this.formDetails.addControl('billableType', new FormControl(this.engagementForm.get('billableType').value, Validators.required));
        this.formDetails.addControl('manager', new FormControl(this.engagementForm.get('manager').value));
        this.formDetails.addControl('partner', new FormControl(this.engagementForm.get('partner').value));
        this.formDetails.addControl('gstCode', new FormControl(this.engagementForm.get('gstCode').value));
      } else {
        this.formDetails.patchValue(this.engagementForm.getRawValue());
      }
    }
    const tripDetailsForm = this.formDetails.get('tripDetails');
    this.watchers.push(
      tripDetailsForm.get('DateSelection').valueChanges.pipe(startWith(null as string), pairwise()).subscribe(this.detectDateChange),
      tripDetailsForm.get('Date Toggle').valueChanges.subscribe(this.handleDateToggleChange.bind(this))
    );
    if (!tripDetailsForm.get('DateSelection').value) {
      const disabledDays = this.bookingCreationCutoff.disabledForWeeks.map(day => {
        return this.weekDaysMapping[day];
      });
      const value = this.utilService.getMoment(this.utilService.getNextPossibleValidDate(this.utilService.getMoment().toDate(), disabledDays));
      tripDetailsForm.get('DateSelection').setValue([value]);
    }
  }

  detectDateChange = ([prev, next]: [any, any]) => {
    if (this.isChangedInCard) {
      this.isChangedInCard = false;
      return;
    }
    const dateWise = this.formDetails.get('dateWise');
    const dateToggle = this.formDetails.get('tripDetails').get('Date Toggle');
    if (dateWise instanceof FormArray) {
      if (dateToggle.value) {
        if (dateWise.length) {
          dateWise.at(0).get('dates').setValue(next);
          if (next.length > 1) {
          this.formDetails.get('tripDetails').get('Date Toggle').setValue(false, {emitEvent: true});
          }
        } else {
          this.addDateView(next);
        }
      } else {
        this.prevDate = prev || this.formDetails.get('tripDetails').get('DateSelection').value;
        this.nextDate = next;
        const datesRemoved = this.prevDate.filter((date): boolean => {
          return next.indexOf(date) > -1 ? false : true;
        });
        if (datesRemoved.length) {
          this.showDateRemoveWarning();
        } else {
          this.handleDateChange();
        }
      }
    }
  }

  handleDateChange() {
    const datesRemoved = this.prevDate.filter((date): boolean => {
      return this.nextDate.indexOf(date) > -1 ? false : true;
    });
    const datesAdded = this.nextDate.filter((date): boolean => {
      return this.prevDate.indexOf(date) > -1 ? false : true;
    });

    datesRemoved.forEach((date) => {
      this.removeDateView([date]);
    });

    datesAdded.forEach((date) => {
      this.addDateView([date]);
    });
    if (this.nextDate.length === 1) {
      this.formDetails.get('tripDetails').get('Date Toggle').setValue(true, {emitEvent: false});
    }
  }

  removeDateView(dates: Date[]) {
    const dateWise = this.formDetails.get('dateWise');
    if (dateWise instanceof FormArray) {
      let index = 0;
      for (const trip of dateWise.controls) {
        if (trip.get('dates').value[0] == dates[0]) {
          dateWise.removeAt(index);
          break;
        }
        index++;
      }
    }
  }

  addDateView(dates: Date[]) {
    const dateWise = this.formDetails.get('dateWise');

    const newDateForm = this.formBuilder.group({
      dates: this.formBuilder.control(dates),
      cabs: this.formBuilder.array([])
    });

    this.constructForm(newDateForm, this.dateWiseConfig);
    if (Number(this.cabCountConfig.config.values[0]) === 1) {
      newDateForm.get('CabCount').disable();
    }
    if (dateWise instanceof FormArray) {
      dateWise.push(newDateForm);
    }
  }

  showDateRemoveWarning() {
    this.isDateRemoveWarning = true;
  }

  hideDateRemoveWarning() {
    this.isDateRemoveWarning = false;
  }

  onDateChangeApprove = () => {
    this.handleDateChange();
    this.hideDateRemoveWarning();
  }

  onDateChangeCancel = () => {
    this.formDetails.get('tripDetails').get('DateSelection').setValue(this.prevDate, {emitEvent: true});
    this.hideDateRemoveWarning();
  }

  onDateMergeApprove = () => {
    const dateWise = this.formDetails.get('dateWise');
    const dates = this.formDetails.get('tripDetails').get('DateSelection').value;
    if (dateWise instanceof FormArray) {
      dateWise.at(0).get('dates').setValue(dates);
      while (dateWise.length > 1) {
        dateWise.removeAt(1);
      }
    }
    this.hideDateMergeWarning();
  }

  showDateMergeWarning() {
    this.isDateMergeWarning = true;
  }

  hideDateMergeWarning() {
    this.isDateMergeWarning = false;
  }

  onDateMergeCancel = () => {
    this.formDetails.get('tripDetails').get('Date Toggle').setValue(false, {emitEvent: false});
    this.hideDateMergeWarning();
  }

  handleDateToggleChange = (value) => {
    if (value) {
      this.showDateMergeWarning();

    } else {
      const dateWise = this.formDetails.get('dateWise');
      const dates = this.formDetails.get('tripDetails').get('DateSelection').value;
      if (dateWise instanceof FormArray) {
        dateWise.at(0).get('dates').setValue([dates[0]], {emitEvent: false});
        dates.slice(1).forEach((date) => {
          const clone = this.cloneAbstractControl(dateWise.at(0));
          clone.reset();
          clone.get('dates').setValue([date]);
          this.dateWiseConfig.forEach((item) => {
            clone.get(item?.elementKey).setValue(item?.config.defaultValue);
        });
          dateWise.push(clone);
        });
      }
    }
  }

  onDateChangeInCard = () => {
    let dates = [];
    const dateWise = this.formDetails.get('dateWise');
    dateWise['controls'].forEach((dateForm) => {
      dates = dates.concat(dateForm.get('dates').value);
    });
    this.isChangedInCard = true;
    this.formDetails.get('tripDetails').get('DateSelection').setValue(dates);
  }

  deleteDateCard = (index) => {
    const dateWise = this.formDetails.get('dateWise');
    if (dateWise instanceof FormArray) {
      dateWise.removeAt(index);
      this.onDateChangeInCard();
    }
  }

  onFileInput(event) {
    const file: File = event.target.files[0];
    if (file){
    this.documentUploaded = true;
    this.fileName = file.name;
    const formData = new FormData();
    formData.append("thumbnail", file);
    if (this.uploadedDocumentList.length >= 5) {
      this.uploadDocumentsExceeded = true;
    }
    else if (file.size > 5000000) {
      this.fileSizeExceeded = true;
 }
    else{
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        const file = files.item(i);
        const reader = new FileReader();
        if (file && this.selectedFiles.indexOf(file) < 0) {
          this.selectedFiles.push(file);
        }
        reader.onload = () => {
          if (this.uploadedDocumentList.indexOf({file}) < 0) {
          this.uploadedDocumentList.push({
            filename: files[i].name,
            filesize: (files[i].size / (1024 * 1024)).toFixed(4),
            previewUrl: reader.result as string
          });
          }
          };
        reader.readAsDataURL(files[i]);
      }
   }
  }
}

onDocClicked(index: number){
  const file = this.selectedFiles[index];
  const url = URL.createObjectURL(file);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', file.name);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url); // free memory space
}

deleteDoc(image: any){
  this.deleteDocName = image.filename;
  this.deleteDocPopup = true;

}

removeFile(delDocName) {
  const index = this.uploadedDocumentList.findIndex(file => file.filename == delDocName);
  this.uploadedDocumentList.splice(index, 1);
  this.selectedFiles.splice(index, 1);
  this.deleteDocPopup = false;
}

removeExistingDoc(deleteDocName){
  // delete api
  this.myBookingService.deleteDoc(this.editBookingId, deleteDocName).subscribe(res => {
  const index = this.uploadedDocumentList.findIndex(file => file.filename == deleteDocName);
  this.uploadedDocumentList.splice(index, 1);
  this.showSuccessToast = true;
  this.toastMsg = res;
  });
  this.deleteDocPopup = false;
}

saveDocuments(){
  const request = {
    files: this.selectedFiles
  };
  this.createBookingService.saveDocuments(request, this.createBookingService.isEditMode ? this.editBookingId : '' ).subscribe(res => {
    this.submitDocumentId = res[0];
    this.createBookingService.submittedDocId.next(this.submitDocumentId);
    this.showSuccessToast = true;
    this.toastMsg = "Document saved successfully";
    setTimeout(() => { this.showSuccessToast = false; }, 3000);
  }, (error) => {
    console.error();
  });
  this.createBookingService.savedDocuments.next(this.uploadedDocumentList);
  this.createBookingService.selectedFilesObj.next(this.selectedFiles);
}
  onBackDateToggle(event){
    this.enableBackDatedBooking = event;
    this.createBookingService.createBackDatedBooking.next(event);
 }

 applySameData()
 {
  
const dateWiseArray = this.formDetails.get('dateWise') as FormArray;
const length = dateWiseArray.value.length;
const firstFormGroup = dateWiseArray.at(0) as FormGroup;
// firstFormGroup.get('CabToggle').setValue(false);

const dateValues: any[] = [];
dateWiseArray.controls.forEach((formGroup: FormGroup) => {
    const dateControlName = 'dates';
    dateValues.push(formGroup.get(dateControlName).value);
  });
while (dateWiseArray.length > 1) {
    dateWiseArray.removeAt(1);
  }
for (let i = 1; i < length; i++)
  {
    const form = new FormGroup({});
    Object.keys(firstFormGroup.controls).forEach((res) => {
      form.addControl(res, this.cloneAbstractControl(firstFormGroup.controls[res]));
    });
    dateWiseArray.push(form);
    dateWiseArray.at(i).get('dates').setValue( dateValues[i]);
  }
  // dateWiseArray.setValue(data)
this.hideDateMergeWarning();
 }



 cloneAbstractControl<T extends AbstractControl>(control: T): T {
  let newControl: T;

  if (control instanceof FormGroup) {
    const formGroup = new FormGroup({}, control.validator, control.asyncValidator);
    const controls = control.controls;

    Object.keys(controls).forEach(key => {
      formGroup.addControl(key, this.cloneAbstractControl(controls[key]));
    });

    newControl = formGroup as any;
  }
  else if (control instanceof FormArray) {
    const formArray = new FormArray([], control.validator, control.asyncValidator);

    control.controls.forEach(formControl => formArray.push(this.cloneAbstractControl(formControl)));

    newControl = formArray as any;
  }
  else if (control instanceof FormControl) {
    newControl = new FormControl(control.value, control.validator, control.asyncValidator) as any;
  }
  else {
    throw new Error('Error: unexpected control value');
  }

  if (control.disabled) { newControl.disable({emitEvent: false}); }

  return newControl;
}

handleBillableTypeChange(selectedItem: DropdownItem){
  this.engagementForm.get('billableType').setValue(selectedItem.value);
  this.formDetails.get('billableType').setValue(selectedItem.value);
}
checkDropdownDisable(){
  return this.miscellConfig?.verifyEngagementCode && !this.isAllGuest;
}


  ngOnDestroy() {
    this.watchers.forEach((watcher) => {
      watcher.unsubscribe();
    });
  }

}
